import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Label } from "reactstrap";
import {
  LoginResponseType,
  UserProfileType,
} from "../../../../redux/auth/authTypes";
import { RollingLoader } from "../../../commons";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { DropDownType } from "../../../../commonTypes/clientDirectoryTypes";

type AppProps = {
  data: any;
  isEdit?: boolean | string;
  setProfileForm: any;
  handleUserDeatilsForm?: (data: any) => void;
  profileDetailsError: any;
  isEmail?: number | null;
  emailFetching?: boolean;
  isDisabledEditField?: boolean;
  loginData?: LoginResponseType;
  emailMessage?: string | null;
  skillsText?: string;
  finalSkillList?: DropDownType[] | [];
  setSkillsOffset?: React.Dispatch<React.SetStateAction<number>> | undefined;
  setSkillsText?: React.Dispatch<React.SetStateAction<string>>;
  handleSkillChange?: (data: any) => void;
  skillFetching?: boolean;
  limit?: number | undefined;
};
const BasicDetails = ({
  data,
  isEdit,
  setProfileForm,
  handleUserDeatilsForm,
  profileDetailsError,
  isEmail,
  emailFetching,
  emailMessage,
  loginData,
  isDisabledEditField,
  skillsText,
  finalSkillList,
  setSkillsOffset,
  setSkillsText,
  handleSkillChange,
  skillFetching,
  limit
}: AppProps) => {
  const { pathname } = useLocation();
  let showSkills = pathname.includes("user-profile");
  let show = pathname.includes("external-user");
  const addPresent = useLocation()?.pathname?.includes("add");
  const checkSkillsBottom = () => {
    setSkillsOffset?.((prev: number) => prev + (limit || 0))
  }
  return (
    <div className="form-group">
      <h6>BASIC DETAILS</h6>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="firstName">
            First Name <span className="color-red">*</span>
          </label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className={`form-control ${!!profileDetailsError?.nameError ? "error-border" : null
                }`}
              name="first_name"
              disabled={!isEdit}
              value={data?.first_name || ""}
              required
              onChange={handleUserDeatilsForm}
            />
          </div>
          {!!profileDetailsError?.nameError && (
            <small className="text-danger">
              {profileDetailsError?.nameError}
            </small>
          )}
        </div>
        <div className="col-md-3">
          <label htmlFor="lastName">Last Name</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="last_name"
              disabled={!isEdit}
              value={data?.last_name || ""}
              onChange={handleUserDeatilsForm}
            />
          </div>
        </div>

        <div className="col-md-3">
          <label htmlFor="email">
            Email <span className="color-red">*</span>
          </label>
          <div className="d-flex flex-row position-relative">
            <input
              type="email"
              autoComplete="none"
              className={`form-control ${!!profileDetailsError?.emailError ? "error-border" : null
                }`}
              name="email_id"
              disabled={!isEdit || !!(!addPresent && isDisabledEditField)}
              value={data?.email_id || ""}
              onChange={handleUserDeatilsForm}
            />
            {emailFetching && data?.email_id && <RollingLoader />}
          </div>
          {data?.email_id &&
            isEmail === 1 &&
            emailMessage?.includes("email already exists") ? (
            <small className="text-danger">Email is already in use!</small>
          ) : (
            ""
          )}
          {!!profileDetailsError?.emailError && (
            <small className="text-danger">
              {profileDetailsError?.emailError}
            </small>
          )}
        </div>
        {!show && !showSkills &&

          <div className="col-md-3">
            <label htmlFor="skills">
              Skills
            </label>
            <div className="position-relative">
              <Select
                className="dropdown"
                placeholder={"Select..."}
                value={data?.skill}
                options={finalSkillList}
                isMulti
                isClearable
                onChange={(e) => handleSkillChange?.(
                  e
                )
                }
                isSearchable={true}
                isLoading={skillFetching && (skillsText?.length || 0) > 0}
                onMenuClose={() => setSkillsOffset?.(0)}
                onMenuScrollToBottom={(e: any) => checkSkillsBottom()}
                onInputChange={(e) => {
                  setSkillsText?.(e);
                }}
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default BasicDetails;
